import React from "react";

function WhyCosmosSDK() {
  return (
    <>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Why Choose Cosmos SDK Development?</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  Cosmos SDK enables the creation of custom, interoperable
                  blockchains connected within the Cosmos network. This modular
                  framework promotes scalability and adaptability, making it the
                  preferred choice for businesses looking to enter the
                  blockchain space.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </>
  );
}

export default WhyCosmosSDK;
